import React from 'react';
import './AccountQuickLinks.css';

function AccountQuickLinks({ onShowOrders, onCartClick, onClose, onShowQueries }) {
  const handleContinueShopping = () => {
    onClose();
    setTimeout(() => {
      const productSection = document.getElementById('standard');
      if (productSection) {
        productSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  const handleCart = () => {
    onClose();
    setTimeout(() => {
      if (onCartClick) onCartClick();
    }, 100);
  };

  const handleShowQueries = () => {
    console.log('My Queries button clicked'); // Debug log
    console.log('onShowQueries:', onShowQueries); // Check if prop exists
    if (onShowQueries) {
      onShowQueries();
      console.log('Modal should open now'); // Confirm it was called
    }
  };

  return (
    <div className="quick-links-section">
      <div className="quick-links-grid">
        <button className="quick-link-pill orders" onClick={onShowOrders}>
          <span className="pill-text">My Orders</span>
         
        </button>
        
        <button className="quick-link-pill queries" onClick={handleShowQueries}>
          <span className="pill-text">My Queries</span>
         
        </button>
        
        <button className="quick-link-pill cart" onClick={handleCart}>
          <span className="pill-text">Shopping Cart</span>
         
        </button>
        
        <button className="quick-link-pill shop" onClick={handleContinueShopping}>
          <span className="pill-text">Continue Shopping</span>
        
        </button>
      </div>
    </div>
  );
}

export default AccountQuickLinks;
